import { useCurrentPostHelpers } from "@circle-react/components/PostsV3/useCurrentPostHelpers";
import type { CurrentCommunity } from "@circle-react/types/CurrentCommunity";
import type { Post } from "@circle-react/types/Post";

import { EventDropdownActions } from "./EventDropdownActions";
import { PostDropdownActions } from "./PostDropdownActions";

export interface NewPostActionsDropdownProps {
  currentCommunity?: CurrentCommunity;
  onChange: (data?: Post) => void;
  onPostDestroy: (data: Post) => void;
  refetchPosts?: () => void;
}

export const NewPostActionsDropdown = ({
  onChange,
  onPostDestroy,
  refetchPosts,
  currentCommunity,
}: NewPostActionsDropdownProps) => {
  const { isBasicPost, isEventPost, isImagePost } = useCurrentPostHelpers();
  return (
    <>
      {(isBasicPost || isImagePost) && (
        <PostDropdownActions
          onChange={onChange}
          onPostDestroy={onPostDestroy}
          refetchPosts={refetchPosts}
          currentCommunity={currentCommunity}
        />
      )}
      {isEventPost && (
        <EventDropdownActions
          onChange={onChange}
          onPostDestroy={onPostDestroy}
        />
      )}
    </>
  );
};
